interface IProps {
  title: string;
  rangeUnit?: string;
}

export default function SectionTitle({ title, rangeUnit }: IProps) {
  return (
    <div className="flex items-baseline gap-x-1 pb-2 font-heading font-semibold text-lg text-primary">
      <span>{title}</span>
      {rangeUnit && <span className="text-sm">({rangeUnit})</span>}
    </div>
  );
}
